import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ModalMessageComponent } from '@core/components/modal-message/modal-message.component';
import { ModalMessageData } from '@core/models/modal-message-data.interface';
import { first, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ModalMessageService {
  constructor(private dialog: MatDialog) {}
  public openModalMessage(config: MatDialogConfig<ModalMessageData>): Observable<any> {
    const ref = this.dialog.open(ModalMessageComponent, config);
    return ref.afterClosed().pipe(first());
  }
}
